import type { JSX } from "react";

import { ProjectCreationButton } from "app/modules/project-from-comparison/components/ProjectCreationButton";
import { ProjectCreationModal } from "app/modules/project-from-comparison/components/ProjectCreationModal";
import { ErrorModal } from "app/modules/project-from-comparison/components/StateModals/ErrorModal";
import { SuccessModal } from "app/modules/project-from-comparison/components/StateModals/SuccessModal";
import { ProjectCreationProvider } from "app/modules/project-from-comparison/context";
import { useToggle } from "app/pages/activation/hooks/useToggle";

interface IProjectCreationProps {
    renderButton?: (onClick: () => void) => JSX.Element;
    modalTitle?: string;
    modalSubTitle?: string;
}

export const ProjectCreation = ({ renderButton, modalSubTitle, modalTitle }: IProjectCreationProps) => {
    const [isModalOpen, openModal, closeModal] = useToggle();
    const [isSuccessModalOpen, openSuccessModal, closeSuccessModal] = useToggle();
    const [isErrorModalOpen, openErrorModal, closeErrorModal] = useToggle();

    return (
        <ProjectCreationProvider>
            <ProjectCreationModal
                isOpen={isModalOpen}
                onClose={closeModal}
                openSuccessModal={openSuccessModal}
                openErrorModal={openErrorModal}
                title={modalTitle}
                subtitle={modalSubTitle}
            />
            <SuccessModal
                isOpen={isSuccessModalOpen}
                onClose={closeSuccessModal}
            />
            <ErrorModal
                isOpen={isErrorModalOpen}
                onClose={closeErrorModal}
            />

            {renderButton ? renderButton(openModal) : <ProjectCreationButton onClick={openModal} />}
        </ProjectCreationProvider>
    );
};
